import {SettingsLoaderService} from '@supoui/core/services/settings.loader.service';
import {initializeAppSettings} from './app-init-settings';
import {initializeKeycloak} from "@supoui/shared/util/keycloak-init";
import {KeycloakService} from "keycloak-angular";
import {ApplicationSettings} from "@supoui/shared/model/application.settings";

export function initializeApp(settingsLoaderService: SettingsLoaderService, keycloakService: KeycloakService): () => Promise<any> {
  return async (): Promise<boolean> => {
    return initializeAppSettings(settingsLoaderService).then((settings: ApplicationSettings) => initializeKeycloak(keycloakService, settings));
  }
}
